module.exports = __webpack_public_path__ + "static/media/industry.5ec44869.jpg";